import store from '@/store'

export function versionGuard(to, from, next) {
  if (process.env.VUE_APP_RELEASE !== store.state.clientVersion) {
    window.location = to.fullPath
    return
  }
  return next()
}
